import 'owl.carousel/dist/assets/owl.carousel.css'
import Slider from "../Sections/home/Slider";
import Facts from "../Sections/home/Facts";
import About from "../Sections/home/About";
import Price from "../Sections/home/Price";
import Testimonial from "../Sections/home/Testimonial";
import Logos from "../Sections/home/Logos";
import LastBlog from '../Sections/home/LastBlog';
import Faq from '../Sections/home/Faq';
import { useHomepageQuery } from '../Redux/Apis/authApi';
import Loading from '../Layouts/Loading';
import Error404 from '../Layouts/Error404';
import { useEffect } from 'react';
// @ts-ignore
import WOW from 'wowjs/dist/wow'
import MetaTags from '../Components/MetaTags';

function Home() {
    const { data, isSuccess, isLoading } = useHomepageQuery()
    useEffect(() => {
        if (isSuccess) {
            new WOW.WOW({
                live: true
            }).init();
        }
    }, [isSuccess])

    if(isLoading) return <Loading />

    else if(isSuccess && data) {
        return ( 
            <>
            <MetaTags
                siteName="سایت مرجع آزمون GRE"
                title="سایت مرجع آزمون GRE"
                description="سایت GREhub شبیه ساز حرفه ای آزمون های بین المللی GRE با این هدف راه اندازی شده است که شما داوطلبان گرامی بتوانید سوالات واقعی آزمون GRE، مثل کراون Crown، دالائو Dalao و سایر سوالات اصلی را در محیط شبیه ساز آزمون به صورت آنلاین تمرین کنید، تا مدیریت زمان را به خوبی فراگرفته، و در نتیجه در سنتر و موقع آزمون اصلی بهترین نمره را به راحتی بدست آورید و سپس از دانشگاه های مورد نظرتان به آسانی پذیرش بگیرید."
                url="https://grehub.org"
                image="https://grehub.org/GREhub_LOGO.jpg"
                ogType="website"
                twitterCard="summary_large_image"
            />
            <Slider data={data.sliders}/>
            <Facts data={data.count}/>
            <About />
            <Price data={data.packages}/>
            <LastBlog data={data.LastBlog}/>
            <Testimonial data={data.comments}/>
            <Faq data={data.faq}/>
            <Logos />
            </>
        );
    }

    else return <Error404 />
}

export default Home;
